 //trial是体验版  release是正式版
//注。当发行wx小程序的时候 manifest.json 文件里的微信小程序配置的appid也要与weChatAppid一致
let isTest = true




isTest = process.env.NODE_ENV == 'development' ? true : false // 是否是测试环境



//优先正式环境，防止发布后采用了测试环境
//打开查看线上环境
// isTest = false;

// 测试环境
let apiUrl ="https://pssapi.jkxg365.com"
let webUrl ="https://pssapi.jkxg365.com"

// 正式环境
if(!isTest){
	apiUrl ="https://pssapi.jkxg365.com"
	webUrl ="https://pssapi.jkxg365.com" 
}

// 共用参数
let wxkf = {
	'url' : "",
	'qyId' : "",
}

export const config = {
    apiUrl:apiUrl,
    webUrl:webUrl,
    wxkf:wxkf,
}